export default function DocumentSupportingDocumentController(
  $q,
  $rootScope,
  $scope,

  alerts,
  pmDataService,
  pmSharedModelService,
  confirmDialog,
  docDataService,
  loaderService,
  orgDataService,
  editDocumentAttachmentDialog,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.canDeleteItem = vm.canDelete;
  vm.canEditItem = vm.canEdit;

  // Attach Event Handlers
  vm.handleEditSupportingDocument = _handleEditSupportingDocument;
  vm.handleDeleteSupportingDocument = _handleDeleteSupportingDocument;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleEditSupportingDocument($event) {
    ssDialogService.dialogs.pm.editDocumentAttachmentDialog = ssDialogService.alert(
      editDocumentAttachmentDialog.getOptions($event, {
        document: {
          policyDocumentId: vm.policyDocumentId,
        },
        attachment: vm.supportingDocument,
        attachmentType: 'supportingDocument',
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pm.editDocumentAttachmentDialog);
  }

  function _handleDeleteSupportingDocument($event) {
    ssDialogService.dialogs.pm.deleteDocumentSupportingDocumentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Attached Document?',
        message: `Are you sure you want to delete document "${vm.supportingDocument.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.pm.deleteDocumentSupportingDocumentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return pmDataService.deleteDocumentSupportingDocument(vm.supportingDocument.policyDocumentSupportingDocumentId)
      .then(() => {
        alerts.success('The document has been deleted successfully.');
        $rootScope.$broadcast('refreshPMDocumentAttachments',
          { policyDocumentId: vm.supportingDocument.policyDocumentId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while deleting the document.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pm.deleteDocumentSupportingDocumentConfirmDialog);
  }
}

DocumentSupportingDocumentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',

  'alerts',
  'pmDataService',
  'pmSharedModelService',
  'confirmDialog',
  'docDataService',
  'loaderService',
  'orgDataService',
  'editDocumentAttachmentDialog',
  'ssDialogService'
];
